import { FileCheck2, FilePlus2, NotebookPen, type LucideIcon } from "lucide-react";
import type { NewDocumentTranslations } from "@/lib/i18n/types/documents-sections/newDocument";

/** Sections the "New document" modal renders, in visual order. */
export type TemplateSectionId = "franklin";

/**
 * Behavioural traits of a template. These were the card's chips until the ⓘ
 * replaced them, and they no longer resolve to any label — `digitalSigning` is
 * what pre-ticks the signing toggle, and the rest are declarative. Kept as an
 * explicit union rather than a copy key, because there is no copy behind them
 * any more.
 */
export type TemplateTrait = "digitalSigning" | "comingSoon";

/** Template ids are the copy keys, so a template can never ship without copy. */
export type DocumentTemplateId = keyof NewDocumentTranslations["templates"];

/** Icon tint tokens — kept as whole class strings so Tailwind keeps them. */
export type TemplateTint = "blue" | "amber" | "slate";

export const TEMPLATE_TINT_CLASSES: Record<TemplateTint, string> = {
  blue: "bg-blue-50 text-blue-600",
  amber: "bg-amber-50 text-amber-600",
  slate: "bg-slate-100 text-slate-500",
};

export interface DocumentTemplate {
  id: DocumentTemplateId;
  /** The section the template lives in. */
  section: TemplateSectionId;
  icon: LucideIcon;
  tint: TemplateTint;
  traits: TemplateTrait[];
  /** A deliberate "coming soon" placeholder — rendered, but not selectable. */
  disabled?: boolean;
}

/**
 * The template catalogue. Static data until templates are org-configurable;
 * the modal reads names and descriptions from i18n by `id`.
 */
export const DOCUMENT_TEMPLATES: DocumentTemplate[] = [
  {
    id: "coveredWorksAct",
    section: "franklin",
    icon: FileCheck2,
    tint: "blue",
    traits: ["digitalSigning"],
  },
  {
    id: "constructionDiary",
    section: "franklin",
    icon: NotebookPen,
    tint: "amber",
    traits: [],
  },
  {
    id: "moreFranklinTemplates",
    section: "franklin",
    icon: FilePlus2,
    tint: "slate",
    traits: ["comingSoon"],
    disabled: true,
  },
];
